import { Component, OnInit } from '@angular/core';
import { ProjectsService } from 'app/_services/projects.service';
const moment = require('moment');
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { DiscussionTotalReportService } from './discussion-total-report.service';

@Component({
  selector: 'app-discussion-total-report',
  templateUrl: './discussion-total-report.component.html',
  styleUrls: ['./discussion-total-report.component.scss']
})
export class DiscussionTotalReportComponent implements OnInit {


  brandDropDownSettings: any;
  brandSelected = [];
  brandSelectedFilter = [];
  brands = [];

  reportName = "";
  dataReport: Object;

  projectDropDownSettings: any;
  projectSelected = [];
  projectSelectedFilter = [];
  projects = [];

  typeReport = 'day';
  typeReportFilter = 'day';
  notSpam = false;
  typeAction = 'create';

  dtOptions: DataTables.Settings = {};
  dataList = [];
  dataTableShow = false;
  currentConfigItem: object;
  modalRef: BsModalRef;
  modalRef2: BsModalRef;
  daterange: any = {
    start: moment().subtract(1, "days").startOf('day'),
    end: moment().subtract(1, "days").endOf('day')
  };
  daterangeFilter: any = {
    start: moment().subtract(7, "days").startOf('day'),
    end: moment().subtract(1, "days").endOf('day')
  };

  options = {
    locale: {
      format: 'DD/MM/YYYY', //  HH:mm:ss
      applyLabel: 'Áp dụng',
      cancelLabel: 'Hủy',
      fromLabel: 'Từ',
      toLabel: 'Tới',
      customRangeLabel: 'Tùy chọn',
      daysOfWeek: ['CN', 'Hai', 'Ba', 'Tư', 'Năm', 'Sáu', 'Bảy'],
      monthNames: ['Tháng 1 -', 'Tháng 2 -', 'Tháng 3 -', 'Tháng 4 -', 'Tháng 5 -', 'Tháng 6 -',
        'Tháng 7 -', 'Tháng 8 -', 'Tháng 9 -', 'Tháng 10 -', 'Tháng 11 -', 'Tháng 12 -']
    },
    timePicker: false,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().subtract(1, "days").endOf('day').toDate(),
    startDate: this.daterange.start,
    endDate: this.daterange.end,
    ranges: {
     // 'Toàn thời gian': [moment('20170429').startOf('day'), moment().endOf('day')], 
     // '24 giờ': [moment().subtract(1, 'day'), moment()],
     'Hôm nay': [moment().startOf('day'), moment().endOf('day')],
     'Hôm qua': [moment().subtract(1, 'day').startOf('day'), moment().subtract(1, 'day').endOf('day')],
     'Tuần này': [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
     'Tuần trước': [moment().subtract(1, 'week').startOf('isoWeek'), moment().subtract(1, 'week').endOf('isoWeek')],
     'Tháng này': [moment().startOf('month'), moment().endOf('month')],
     'Tháng trước': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
    }
  };

  optionsFilter = {
    locale: { format: 'DD/MM/YYYY' },
    timePicker: false,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().endOf('day').toDate(),
    startDate: this.daterangeFilter.start,
    endDate: this.daterangeFilter.end
  };

  listPosts = [];
  typeSentimentPost = 'neg';

  arrayPost = [];
  ckeditorContent = '';
  showSuggestPost = false;

  currentSourceEdit = 'facebook';

  constructor(
    private projectsService: ProjectsService,
    private toastrService: ToastrService,
    private discussionTotalReportService: DiscussionTotalReportService,
    private modalService: BsModalService
  ) {
    this.getDataFromServer();
    this.getProject();
    this.getReportManager();
  }

  ngOnInit(): void {
    this.brandDropDownSettings = {
      singleSelection: false,
      text: 'Chọn thương hiệu',
      selectAllText: 'Chọn tất cả',
      unSelectAllText: 'Bỏ chọn tất cả',
      enableSearchFilter: false,
      badgeShowLimit: 2,
    };
    this.projectDropDownSettings = {
      singleSelection: false,
      text: 'Chọn chủ đề',
      selectAllText: 'Chọn tất cả',
      unSelectAllText: 'Bỏ chọn tất cả',
      enableSearchFilter: false,
      badgeShowLimit: 2,
    };
    this.dtOptions = {
      pagingType: 'full_numbers',
      ordering: true,
      searching: true,
      paging: true,
      language: {
        infoEmpty: 'Không tìm thấy dữ liệu',
        infoFiltered: '(trong _MAX_ )',
        info: 'Hiển thị _START_ - _END_ trên _TOTAL_',
        lengthMenu: 'Hiển thị _MENU_ ',
        search: 'Tìm kiếm',
        zeroRecords: 'Không có dữ liệu !',
        paginate: {
          first: '<<',
          previous: '<',
          next: '>',
          last: '>>',
        }
      },
      columnDefs: [
        { 'targets': [0, 1, 2, 3, 4, 5], 'searchable': true }
      ]
    };
  };

  selectedDate(value: any, datepicker?: any) {
    datepicker.start = value.start.startOf('day');
    datepicker.end = value.end.endOf('day');
    this.daterange.start = value.start;
    this.daterange.end = value.end;

    this.options.startDate = this.daterange.start;
    this.options.endDate = this.daterange.end;
  }

  selectedDateFilter(value: any, datepicker?: any) {
    datepicker.start = value.start.startOf('day');
    datepicker.end = value.end.endOf('day');
    this.daterangeFilter.start = value.start;
    this.daterangeFilter.end = value.end;
  }

  showPreviewReport(item, modalRef) {
    this.typeAction = 'view';
    this.dataReport = {};
    this.dataReport = JSON.parse(JSON.stringify(item));
    this.modalRef2 = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'custom-modal'
    });
  }

  showCreateReport(modalRef) {
    this.typeAction = 'create';
    this.dataReport = {};
    this.modalRef2 = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'custom-modal'
    });
  }

  getProject() {
    this.projectsService.index().subscribe(response => {
      if (response.success) {
        response.data.projects.forEach(element => {
          let projectItem = {
            id: element._id,
            itemName: element.name,
            value: element.name
          };
          this.projects.push(projectItem);
        });
      }
    });

  }

  getDataFromServer() {
    this.dataTableShow = false;
    this.discussionTotalReportService.getAll().subscribe(res => {
      if (res.success) {
        res.data.forEach(element => {
          let obj = {
            id: element._id,
            itemName: element.name,
            value: element.name
          };
          this.brands.push(obj);
        });
      } else {
        this.toastrService.error('Lỗi hệ thống, Vui lòng liên hệ admin', ' Thông báo')
      }
    });
  }

  getReportManager() {
    let filter = {
      gte: this.daterangeFilter.start.valueOf(),
      lte: this.daterangeFilter.end.valueOf(),
      projects: this.projectSelectedFilter,
      brands: this.brandSelectedFilter,
      typeReport: this.typeReportFilter,
      report_code: ["BCTLTL"]
    };
    this.dataTableShow = false;
    this.discussionTotalReportService.getAllReportManager(filter).subscribe(response => {
      this.dataTableShow = true;
      this.dataList = response.data;
    });
  }


  clickReport() {
    let dateStartEnd = {
      start: moment(this.daterange.start.valueOf()),
      end: moment(this.daterange.end.valueOf())
    }

    let lastDate = dateStartEnd.start.valueOf() - 1 * 24 * 60 * 60 * 1000;
    if (this.typeReport == "week") {
      lastDate = dateStartEnd.start.valueOf() - 7 * 24 * 60 * 60 * 1000;
    } else if (this.typeReport == "month") {
      lastDate = dateStartEnd.start.subtract(1, 'months').valueOf();
    } else if (this.typeReport == "year") {
      lastDate = dateStartEnd.start.subtract(1, 'years').valueOf();
    } else if (this.typeReport == "option") {
      let dayRange = Math.ceil((dateStartEnd.end.valueOf() - dateStartEnd.start.valueOf()) / (1 * 24 * 60 * 60 * 1000));
      lastDate = dateStartEnd.start.valueOf() - dayRange * 24 * 60 * 60 * 1000;
    }
    if (this.brandSelected.length == 0 && this.projectSelected.length == 0) {
      this.toastrService.warning("Bạn phải chọn thương hiệu hoặc chủ đề", "Thông báo!");
      return;
    }
    else if (this.brandSelected.length > 5 || this.projectSelected.length > 5) {
      this.toastrService.warning("Chỉ được chọn tối đa 5 thương hiệu hoặc chủ đề", "Thông báo!");
      return;

    }
    this.dataReport = {};
    this.arrayPost = [];

    let filter = {
      gte: lastDate,
      from: this.daterange.start.valueOf(),
      lte: this.daterange.end.valueOf(),
      projects: this.projectSelected,
      brands: this.brandSelected,
      type: this.typeReport,
      notSpam : this.notSpam
    };
    this.discussionTotalReportService.getReport({ filter: filter , index:  'full' }).subscribe(response => {
      let data = response.data;
      if (data) {
        let dataFilter = data.aggregations.dataFilter;
        let dataLastFilter = data.aggregations.dataLastFilter;
        let dataReportFilter = {
          total: 0,
          name: this.generalName(this.typeReport, filter.from, filter.lte),
          data: {}
        };

        for (const property in dataFilter) {
          if (property != "doc_count" && property != "meta") {
            dataReportFilter.data[property] = dataFilter[property].doc_count;
            dataReportFilter.total += dataFilter[property].doc_count;
          }
        }
        let dataLastReportFilter = {
          total: 0,
          name: this.generalName(this.typeReport, lastDate, filter.from),
          data: {}
        };
        for (const property in dataLastFilter) {
          if (property != "doc_count" && property != "meta") {
            dataLastReportFilter.data[property] = dataLastFilter[property].doc_count;
            dataLastReportFilter.total += dataLastFilter[property].doc_count;
          }
        }
        this.dataReport = {
          report_desc: "Báo cáo tổng lượng thảo luận các thương hiệu",
          report_type: this.typeReport,
          report_name: "Báo cáo tổng lượng thảo luận các thương hiệu " + this.generalName(this.typeReport, filter.from, filter.lte),
          report_project: this.projectSelected,
          report_brand: this.brandSelected,
          report_start_date: new Date(this.daterange.start.valueOf()),
          report_end_date: new Date(this.daterange.end.valueOf()),
          report_code: "BCTLTL", // báo cáo tổng lượng thảo luận
          data: {
            dataReportFilter: dataReportFilter,
            dataLastReportFilter: dataLastReportFilter,
            colorGeneral: data.colorGeneral,
            htmlTop: ""
          }
        }
        console.log(this.dataReport);
      }
    });
    // console.log(filter);
  }
  generalName(typeReport, start, end) {
    let name = "";
    let dayTime = 24 * 60 * 60 * 1000;
    if (typeReport == "day" && (end - start) <= dayTime) {
      name = "Ngày " + moment(start).format('DD/MM/Y');
    } else if (typeReport == "month" && (end - start) <= (31 * dayTime) && moment(start).format('MM/Y') == moment(end - 1).format('MM/Y')) {
      name = "Tháng " + moment(start).format('MM/Y');
    } else if (typeReport === 'year' && moment(start).year() == moment(end - 1).year()) {
      name = "Năm " + moment(start).year()
    } else {
      name = moment(start).format('DD/MM/Y') + " - " + moment(end - 1).format('DD/MM/Y');;
    }
    return name;
  }
  clickSave() {
    if (this.dataReport) {
      if (this.reportName == "") {
        this.toastrService.warning("Bạn phải nhập tiêu đề cho báo cáo!", "Thông báo!");
        return;
      }
      this.dataReport["report_title"] = this.reportName.trim();
      this.discussionTotalReportService.createReport(this.dataReport).subscribe(response => {
        if (response.success) {
          this.toastrService.success("Đã tạo báo cáo thành công!", "Thông báo!");
          this.getReportManager();
        } else {
          this.toastrService.warning(response.msg, "Thông báo!");
        }
        this.closeModal();
      });
    } else {
      this.toastrService.warning("Không có dữ liệu báo cáo cần cập nhật!", "Thông báo!");
    }
  }
  clickDeleteItem(item, modalRef) {
    this.modalRef = this.modalService.show(modalRef);
    this.currentConfigItem = JSON.parse(JSON.stringify(item));
  }
  clickSaveConfirm(modalRef) {
    if (!this.dataReport) {
      this.toastrService.warning("Không có dữ liệu báo cáo cần cập nhật!", "Thông báo!");
      return;
    }
    this.reportName = "";
    this.modalRef = this.modalService.show(modalRef);
  }

  deleteReport() {
    this.discussionTotalReportService.deleteReport(this.currentConfigItem['_id']).subscribe(res => {
      if (res.success) {
        this.getReportManager();
        this.toastrService.success('Xóa báo cáo thành công !', 'Thông báo');
        this.closeModal();
      } else {
        this.toastrService.error('Xóa báo cáo thất bại !', 'Thông báo');
      }
    });
  }
  closeModal() {
    this.modalRef.hide();
    this.modalRef2.hide();
  }

  pageChange(number) {
    this.listPosts = [];
  }

  async savePosts() {
    let htmlTop = '';
    this.arrayPost.forEach(data => {
      htmlTop += `${data._source.message || data._source.content}<br>`;
    })
    let tempDataReport = JSON.parse(JSON.stringify(this.dataReport));
    tempDataReport['data']['htmlTop'] = htmlTop;
    this.dataReport = {};
    this.dataReport = tempDataReport;

    this.modalRef.hide();
  }

  onItemSelect(item: any) {
  }
  OnItemDeSelect(item: any) {
  }

  onSelectAll(items: any) {
  }

  onDeSelectAll(items: any) {
  }
}


// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-module/discussion-total-report/discussion-total-report.component.ts